export const GOODS = 'goods'
export const REGION = 'showRegions'
export const COMPANY_NAME = 'companyName'
export const COMPANY_FACEBOOK = 'siteUrl'
export const COMPANY_POLICY = 'companyPolicy'
export const COMMENT = 'comment'
export const NAME = 'firstname'
export const EMAIL = 'email'
export const PHONE = 'phone'
export const AGREEMENT = 'dataProcessingPermission'
